import React from "react";

const About = () => {
  return (
    <div className="page pt-about" >
      <section className="container">
        {/* Section Title */}
        <div className="header-page mt-70 mob-mt">
          <h2>About Me</h2>
          <span></span>
        </div>
        {/* Personal Info Start */}

        <div className="row mt-100">
          {/* Information Block */}
          <div className="col-lg-12 col-sm-12">
            <div className="info box-1">
              <div className="row">
                <div className="col-lg-3 col-sm-4">
                  <div className="photo">
                    <img
                      alt="prakash karena"
                      src="https://1.bp.blogspot.com/-tUzO8TTLJcw/YVyRSqMr3kI/AAAAAAAAaZ8/SuA64eBzfZA5KRpv4a0XpgX1jRm3vMJSACLcBGAsYHQ/s640/slide-2.jpg"
                    />
                  </div>
                </div>
                <div className="col-lg-9 col-sm-8">
                  <h4>Prakash Karena</h4>
                  <div className="loc">
                    <i className="fas fa-map-marked-alt"></i> India
                  </div>
                  <p>
                    My name is Prakash Karena, my native place is the City of Porbandar. 
                    I have more then two years of experience in Software Development.
                  </p>
                  <p>
                  I did my graduation from government engineering college rajkot with the course of BE Computer engineering. I did my intermediate from Swami vivekanand school junagadh with the course of Science.
                    </p>
                  <p>
                  Coming to my family, I'm leving in joint family.
                  My father is a farmer, my mother is a homemaker, and I have two siblings.
                  </p>
                </div>

                {/* Icon Info */}
                <div className="col-lg-3 col-sm-4">
                  <div className="info-icon">
                    <i className="fas fa-award"></i>
                    <div className="desc-icon">
                      <h6>2.5+ Years Job</h6>
                      <p>Experience</p>
                    </div>
                  </div>
                </div>

                {/* Icon Info */}
                <div className="col-lg-3 col-sm-4">
                  <div className="info-icon">
                    <i className="fas fa-certificate"></i>
                    <div className="desc-icon">
                      <h6>8+ Projects</h6>
                      <p>Completed</p>
                    </div>
                  </div>
                </div>

                {/* Icon Info */}

                {/* <div className="col-lg-3 col-sm-4">
                                <div className="info-icon">
                                  <i className="fas fa-user-astronaut"></i>
                                  <div className="desc-icon">
                                    <h6>Freelance</h6>
                                    <p>Available</p>
                                  </div>
                                </div>
                              </div> */}
                <div className="col-lg-3 col-sm-12 pt-50">
                  <a
                    href="https://drive.google.com/file/d/1PAAQRDTaYZ7CzOP9z23g4dn2Ia1WnujF/view?usp=sharing"
                    target="blank"
                    className="btn-st"
                  >
                    Download CV
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Interests Row Start */}

        <div className="row mt-100">
          {/* Header Block */}

          <div className="col-md-12">
            <div className="header-box mb-50">
              <h3>My Interests</h3>
            </div>
          </div>

          <div className="col-lg-12 col-sm-12">
            <div className="box-2">
              <div className="row">
                {/* Interests Item  */}
                <div className="col-lg-3 col-sm-6">
                  <div className="inter-icon">
                    <i className="fas fa-music"></i>
                    <div className="desc-inter">
                      <h6>Music</h6>
                    </div>
                  </div>
                </div>

                {/* Interests Item  */}
                <div className="col-lg-3 col-sm-6">
                  <div className="inter-icon">
                    <i className="fas fa-route"></i>
                    <div className="desc-inter">
                      <h6>Travelling</h6>
                    </div>
                  </div>
                </div>

                {/* Interests Item  */}
                <div className="col-lg-3 col-sm-6">
                  <div className="inter-icon">
                    <i className="far fa-image"></i>
                    <div className="desc-inter">
                      <h6>Photos</h6>
                    </div>
                  </div>
                </div>

                {/* Interests Item  */}
                <div className="col-lg-3 col-sm-6">
                  <div className="inter-icon">
                    <i className="fas fa-film"></i>
                    <div className="desc-inter">
                      <h6>Movies</h6>
                    </div>
                  </div>
                </div>

                {/* Interests Item 
                              <div className="col-lg-3 col-sm-6">
                                <div className="inter-icon">
                                  <i className="fas fa-space-shuttle"></i>
                                  <div className="desc-inter">
                                    <h6>Space</h6>
                                  </div>
                                </div>
                              </div> */}

                {/* Interests Item  */}
                <div className="col-lg-3 col-sm-6">
                  <div className="inter-icon">
                    <i className="fas fa-book"></i>
                    <div className="desc-inter">
                      <h6>Books</h6>
                    </div>
                  </div>
                </div>

                {/* Interests Item 
                              <div className="col-lg-3 col-sm-6">
                                <div className="inter-icon">
                                  <i className="fas fa-gamepad"></i>
                                  <div className="desc-inter">
                                    <h6>Video games</h6>
                                  </div>
                                </div>
                              </div> */}

                {/* Interests Item  */}
                <div className="col-lg-3 col-sm-6">
                  <div className="inter-icon">
                    <i className="fas fa-tree"></i>
                    <div className="desc-inter">
                      <h6>Forest</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Service Row Start */}
        <div className="row mt-100">
          {/* Header Block  */}
          <div className="col-md-12">
            <div className="header-box mb-50">
              <h3>Services</h3>
            </div>
          </div>

          {/* Service Item  */}
          <div className="col-lg-6 col-sm-6">
            <div className="service box-1 mb-40">
              <i className="fas fa-desktop"></i>
              <h4>Web Development</h4>
              <p>
                I can create fully functional website in MERN Stack Development.
              </p>
            </div>
          </div>

          {/* Service Item  */}
          <div className="col-lg-6 col-sm-6">
            <div className="service box-2 mb-40">
              <i className="fas fa-mobile-alt"></i>
              <h4>Application Development</h4>
              <p>
                I can build user friendly Android/iOS appliation using
                React-Native.
              </p>
            </div>
          </div>

          {/* Service Item  */}
          <div className="col-lg-6 col-sm-6">
            <div className="service box-2 mb-40">
              <i className="fab fa-github"></i>
              <h4>
                <a
                  className="image-link"
                  target="blank"
                  href="https://github.com/karenaprakash?tab=repositories"
                >
                  Github
                </a>
              </h4>
              <p>
                I have knowledge of Git and
                <a
                  className="btn-st m-3"
                  target="blank"
                  href="https://github.com/karenaprakash?tab=repositories"
                >
                  {" "}
                  Github.
                </a>
              </p>
            </div>
          </div>

          {/* Service Item  */}
          <div className="col-lg-6 col-sm-6">
            <div className="service box-2 mb-40">
              <i className="fab fa-stack-overflow"></i>
              <h4>
                <a
                  className="image-link"
                  target="blank"
                  href="https://stackoverflow.com/users/11982418/prakash-karena"
                >
                  StackoverFlow
                </a>
              </h4>
              <p>
                I like to help people to solve there problems.You can visit my
                <a
                  className="btn-st m-3"
                  target="blank"
                  href="https://stackoverflow.com/users/11982418/prakash-karena"
                >
                  {" "}
                  StackoverFlow
                </a>{" "}
                Profile.
              </p>
            </div>
          </div>

          {/* Service Item  */}
          <div className="col-lg-6 col-sm-6">
            <div className="service box-1 mb-40">
              <i className="fas fa-medkit"></i>
              <h4>Learn with kp</h4>
              <p>
                I like to share my knowledge. You can visit my  
                <a
                  className="btn-st m-3"
                  target="blank"
                  href="https://learnwith-kp.blogspot.com/"
                >
                  {" "}
                  Blog
                </a>{" "}
                for more details
              </p>
            </div>
          </div>
        </div>

        {/* Testimonial Row Start */}
        {/* <div className="row testimonial mt-60">

                        {/* Header Block */}
        {/* <div className="col-md-12"> 
                          <div className="header-box mb-50">
                            <h3>Testimonials</h3>
                          </div>
                        </div>

                        <div className="owl-carousel owl-theme">

                          {/* Testimonail Item  
                          <div className="testimonial-item">
                            <div className="media">
                              <img src={testimonial1} alt="" />
                              <div className="content">
                                <h4>John Doe</h4>
                                <p>Web Development</p>
                              </div>
                              <ul className="rating">
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                              </ul>
                            </div>
                            <div className="comment pt-30">
                              <p>
                                Curabitur eleifend tempor gnceleris eget placeratvel phasellus eget
                                sem just metup consequat gestas facilisis eleifend posure tempor
                                metus sem just metup consequat gestas facilisis eleifend posures
                                temporureture.
									</p>
                            </div>
                          </div>

                          {/* Testimonail Item 
                          <div className="testimonial-item">
                            <div className="media">
                              <img src={testimonial2} alt="" />
                              <div className="content">
                                <h4>Alex Doe</h4>
                                <p>UI/UX Designer</p>
                              </div>
                              <ul className="rating">
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star-half"></i></li>
                              </ul>
                            </div>
                            <div className="comment pt-30">
                              <p>
                                Curabitur eleifend tempor gnceleris eget placeratvel phasellus eget
                                sem just metup consequat gestas facilisis eleifend posure tempor
                                metus sem just metup consequat gestas facilisis eleifend posures
                                temporureture.
									</p>
                            </div>
                          </div>

                          {/* Testimonail Item 
                          <div className="testimonial-item">
                            <div className="media">
                              <img src={testimonial3} alt="" />
                              <div className="content">
                                <h4>David Doe</h4>
                                <p>UI/UX Designer</p>
                              </div>
                              <ul className="rating">
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                                <li><i className="far fa-star"></i></li>
                              </ul>
                            </div>
                            <div className="comment pt-30">
                              <p>
                                Curabitur eleifend tempor gnceleris eget placeratvel phasellus eget
                                sem just metup consequat gestas facilisis eleifend posure tempor
                                metus sem just metup consequat gestas facilisis eleifend posures
                                temporureture.
									</p>
                            </div>
                          </div>
                        </div>
                      </div> */}

        {/* Price Row Start */}
        {/*                     
                      <div className="row mt-100 mb-60">

                        {/* Header Block 
                        <div className="col-md-12">
                          <div className="header-box mb-90">
                            <h3>Price</h3>
                          </div>
                        </div>

                        {/* Price Item 
                        <div className="col-lg-4 col-sm-12">
                          <div className="price box-1">
                            <div className="head-price">
                              <i className="fa fa-user"></i>
                              <h4>Basic</h4>
                            </div>
                            <div className="body-price">
                              <div className="price-plan">
                                <span className="currency">$</span>
                                <span className="number">25</span>
                                <span className="period">month</span>
                              </div>
                              <div className="list-price">
                                <ul>
                                  <li>Web Design</li>
                                  <li>Web Development</li>
                                  <li className="disable">Responsive Design</li>
                                  <li className="disable">Game Development</li>
                                </ul>
                              </div>
                            </div>
                            <div className="footer-price">
                              <a href="#" className="btn-st">Buy Now</a>
                            </div>
                          </div>
                        </div>

                        {/* Price Item 
                        <div className="col-lg-4 col-sm-12">
                          <div className="price box-2">
                            <div className="head-price">
                              <i className="fa fa-briefcase"></i>
                              <h4>Standard</h4>
                            </div>
                            <div className="body-price">
                              <div className="price-plan">
                                <span className="currency">$</span>
                                <span className="number">40</span>
                                <span className="period">month</span>
                              </div>
                              <div className="list-price">
                                <ul>
                                  <li>Web Design</li>
                                  <li>Web Development</li>
                                  <li>Responsive Design</li>
                                  <li className="disable">Game Development</li>
                                </ul>
                              </div>
                            </div>
                            <div className="footer-price">
                              <a href="#" className="btn-st">Buy Now</a>
                            </div>
                          </div>
                        </div>

                        {/* Price Item 
                        <div className="col-lg-4 col-sm-12">
                          <div className="price box-1">
                            <div className="head-price">
                              <i className="fa fa-globe"></i>
                              <h4>Premium</h4>
                            </div>
                            <div className="body-price">
                              <div className="price-plan">
                                <span className="currency">$</span>
                                <span className="number">55</span>
                                <span className="period">month</span>
                              </div>
                              <div className="list-price">
                                <ul>
                                  <li>Web Design</li>
                                  <li>Web Development</li>
                                  <li>Responsive Design</li>
                                  <li>Game Development</li>
                                </ul>
                              </div>
                            </div>
                            <div className="footer-price">
                              <a href="#" className="btn-st">Buy Now</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    */}
      </section>
    </div>
  );
};

export default About;
